import { createAction } from 'redux-actions';

export const getPhotoSets = createAction('GET_PHOTOSETS');
export const getPhotoSetsSuccess = createAction('GET_PHOTOSETS_SUCCESS', sets => ({ sets }));
export const getPhotoSetsFail = createAction('GET_PHOTOSETS_FAIL', error => ({ error }));

export const searchPhotoSets = createAction('SEARCH_PHOTOSETS', query => ({ query }));
export const searchPhotoSetsSuccess = createAction('SEARCH_PHOTOSETS_SUCCESS', sets => ({ sets }));
export const searchPhotoSetsFail = createAction('SEARCH_PHOTOSETS_FAIL', error => ({ error }));

export const getPhotoSetById = createAction('GET_PHOTOSET_BY_ID', id => ({ id }));
export const getPhotoSetByIdSuccess = createAction('GET_PHOTOSET_BY_ID_SUCCESS', current => ({ current }));
export const getPhotoSetByIdFail = createAction('GET_PHOTOSET_BY_ID_FAIL', error => ({ error }));

export const addPhotoSet = createAction('ADD_PHOTOSET', set => ({ set }));
export const addPhotoSetSuccess = createAction('ADD_PHOTOSET_SUCCESS', set => ({ set }));
export const addPhotoSetFail = createAction('ADD_PHOTOSET_FAIL', error => ({ error }));

export const updatePhotoSet = createAction('UPDATE_PHOTOSET', set => ({ set }));
export const updatePhotoSetSuccess = createAction('UPDATE_PHOTOSET_SUCCESS', set => ({ set }));
export const updatePhotoSetFail = createAction('UPDATE_PHOTOSET_FAIL', error => ({ error }));

export const setPhotoSetCount = createAction('SET_PHOTOSET_COUNT', count => ({ count }));
export const setPhotoSetPage = createAction('SET_PHOTOSET_PAGE', page => ({ page }));
export const setPhotoSetQuery = createAction('SET_PHOTOSET_QUERY', query => ({ query }));
